import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      val: ["", "", "", "", "", "", "", ""],
      activeIndex: this.editable ? 0 : undefined
    };
  },
  watch: {
    activeIndex: function activeIndex() {
      this.$emit("activeChange", this.activeIndex);
    },
    value: {
      immediate: true,
      handler: function handler() {
        if (this.val.join("") === this.value) {
          return;
        }

        var val = this.value.split("");

        if (this.editable) {
          this.activeIndex = val.length;
        }

        while (val.length < 8) {
          val.push("");
        }

        this.val = val;
      }
    },
    val: function val() {
      this.$emit("input", this.val.join(""));
    }
  },
  methods: {
    handleClickItem: function handleClickItem(index) {
      if (!this.editable) {
        return;
      }

      this.activeIndex = index;
    },
    setValue: function setValue(val) {
      this.$set(this.val, this.activeIndex, val);

      if (this.activeIndex < 7) {
        this.activeIndex += 1;
      }
    },
    del: function del() {
      this.$set(this.val, this.activeIndex, "");

      if (this.activeIndex > 0) {
        this.activeIndex -= 1;
      }
    }
  }
};